import "@/public-path";
import "@/assets/scss/_main.scss";
import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";
import VueIziToast from "vue-izitoast";
import App from "@/App.vue";
import store from "@/core/store/index.js";

Vue.config.productionTip = true;

Vue.use(BootstrapVue);
Vue.use(VueIziToast, {
  position: "bottomCenter",
});

const appElement = document.querySelector("#app > app");
const appProps = {
  courseId: appElement?.getAttribute("course-id") ?? "",
  logoUri: appElement?.getAttribute("logo-uri") ?? "",
  sessionToken: appElement?.getAttribute("session-token") ?? "",
};

new Vue({
  store,
  render: (createElement) => createElement(App, {
    props: appProps,
  }),
}).$mount("#app");
